import React, { useEffect, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import CenteredContainer from '../components/ui/CenteredContainer'
import { useAuth } from '../hooks/context/UserAuthContext'
import { Navigate, useLocation, useNavigate, Link as RouterLink, useParams } from 'react-router-dom'
import ResetPasswordForm from '../components/forms/ResetPasswordForm'

const ResetPassword = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  return !token ? (
    <Navigate to='/' replace />
  ) : (
    <CenteredContainer maxWidth='sm' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Reset Password</Typography>
      </Box>
      <ResetPasswordForm token={token} />
    </CenteredContainer>
  )
}

export default ResetPassword
